import React from 'react';
import ProductImage from '../../common/ProductImage';

export default function ProductRow(props) {
    let product = props.product;

    const numberToPrice = numberField => {
        return '£' + numberField.toFixed(2);
    };

    const isPromo = product.costPromotion || product.rspPromotion;

    return (
        <tr className={isPromo ? 'promo-row' : undefined}>
            <td className={'image-column'}>
                <ProductImage src={product.image} alt={'Brandbank image for ' + product.productDescription} />
            </td>
            <td>{props.code}</td>
            <td>
                <p>
                    <span className={'promo-icon'}>{isPromo && 'P'}</span>
                    {product.productDescription.toUpperCase()}
                </p>
                <p className={'barcode'}>{product.innerBarcode}</p>
            </td>
            <td>{product.supplierCode}</td>
            <td>{product.unitSize}</td>
            <td className={isPromo ? 'promo-cost' : 'greenField'}>{numberToPrice(product.cost)}</td>
            <td className={'greenField'}>
                <p>{numberToPrice(product.rsp)}</p>
                <p className={'barcode greenField'}>
                    {product.maximumAllowableRsp != null &&
                        numberToPrice(product.maximumAllowableRsp) + ' MRP'}
                </p>
            </td>
            <td className={'greenField'}>{product.margin != null && product.margin.toFixed(2) + '%'}</td>
            <td className={'greenField'}>{product.vatRate.toFixed(2)}%</td>
        </tr>
    );
}
